// src/Dashboard/pages/user/PassageCeintureDocuments/components/PassageCeintureDocumentsKpis.jsx

import React from "react";
import {
  FaCheckCircle,
  FaFileAlt,
  FaFilePdf,
  FaLayerGroup,
  FaPen,
} from "react-icons/fa";

const baseCards = [
  {
    key: "total",
    label: "Documents",
    icon: FaFileAlt,
    tone: "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
  },
  {
    key: "published",
    label: "Publiés",
    icon: FaCheckCircle,
    tone: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
  },
  {
    key: "withPdf",
    label: "Avec PDF",
    icon: FaFilePdf,
    tone: "border-red-200 bg-red-50 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300",
  },
  {
    key: "belts",
    label: "Ceintures",
    icon: FaLayerGroup,
    tone: "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
  },
];

export default function PassageCeintureDocumentsKpis({
  stats,
  loading,
  canManage,
}) {
  const cards = canManage
    ? [
        ...baseCards,
        {
          key: "drafts",
          label: "Brouillons",
          icon: FaPen,
          tone: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
        },
      ]
    : baseCards;

  return (
    <div
      className={`grid gap-3 ${
        canManage ? "grid-cols-2 lg:grid-cols-5" : "grid-cols-2 lg:grid-cols-4"
      }`}
    >
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-[24px] border px-4 py-4 shadow-sm ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {loading ? "…" : stats?.[card.key] ?? 0}
              </span>
            </div>

            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}